var map = {
	"./100percent.png": 79915,
	"./10percent.png": 91161,
	"./20percent.png": 74594,
	"./30percent.png": 22227,
	"./40percent.png": 70604,
	"./50percent.png": 77341,
	"./60percent.png": 54694,
	"./70percent.png": 24983,
	"./80percent.png": 21872,
	"./90percent.png": 28113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82505;